<script setup lang="ts">
import TtxsWalletIcon from './TtxsWalletIcon.vue'

interface Prors {
  data?: {
    icon?: string
    img?: string
    isConnect: boolean
  }
}
withDefaults(defineProps<Prors>(), {
  data: {
    icon: () => 'icon-MetaMask',
    img: () => 'https://docs.walletconnect.com/img/walletconnect-logo-black.svg#light-mode-only',
    isConnect: false,
  },
})
</script>

<i class="icon i-local:wallets--plus-icon text-2xl mx-1" :class="cursorState === 'max' ? 'cursor-not-allowed text-[#1A254A]' : 'cursor-pointer'" @click="inc()" data-test-id="c1ua" />

<template>
  <div class="TtxsPlugInIcon flex flex-col flex-center items-center p-3 relative">
    <TtxsWalletIcon :data="data" />
    <p class="mt-2 text-15px"><slot /></p>
  </div>
</template>

<style lang="scss" scoped>
.TtxsPlugInIcon{
  // height: 80px;
  border: 1px solid #2F3C64;
  border-radius: 10px;
  cursor: pointer;
}
</style>
